import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const PurchasebyVendor = (props) => {
    const parentDatas = props
    
  const expansionPurchaseVendor = (data) => {
    return (
      <div className="">
        <DataTable
          stripedRows
          value={data.purchaseExpensesList}
          className="expand-table"
        >
          <Column field="purchaseCode" header="Purchase Code"></Column>
          <Column field="companyName" header="Company Name"></Column>
          <Column field="email" header="Email"></Column>
          <Column
            field="balancePayment"
            header=" Balance Amount"
            className="text-end amount-align"
            body={(a) => parentDatas.currency + " " + a?.balancePayment.toFixed(2)}
          ></Column>
          <Column
            field="totalAmount"
            header=" Total Amount"
            className="text-end amount-align"
            body={(a) => parentDatas.currency + " " + a?.totalAmount.toFixed(2)}
          ></Column>
          <Column
            field="renderStatusColumn"
            header="Status"
            body={(e) => parentDatas.statusBodyTemplatePurchaseVendor(e)}
          ></Column>
        </DataTable>
      </div>
    );
  };
  return (
    
  <div className="card">
            <DataTable 
                 stripedRows
                 tableStyle={{ minWidth: "100%" }}
                 value={parentDatas.purchasebyVendor}  
                 expandedRows={parentDatas.expandedRows}
                 onRowToggle={(e) => parentDatas.setExpandedRows(e.data)}
                 rowExpansionTemplate={expansionPurchaseVendor}
                 emptyMessage="No user available">
                <Column expander={parentDatas.allowExpansionPurchaseVendor} style={{ width: "4rem" }} />
                <Column field="vendorName" header="Vendor Name"></Column>
                <Column field="purchaseCount" header="Purchase Count"></Column>
                <Column field="purchaseAmount" header="Amount" className="text-end amount-align" body={(row) => parentDatas.currency + " " + row.purchaseAmount.toFixed(2)} ></Column>
                <Column field="purchaseWithTax" header="Amount (With Tax)" className="text-end amount-align" body={(row) => parentDatas.currency + " " + row.purchaseWithTax.toFixed(2)} ></Column>
            </DataTable>
        </div>
  )
}

export default PurchasebyVendor